<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Col span="12">
                      <FormItem label="发票名称" prop="title">
                        <Input v-model="Forms.title" clearable placeholder=""/>
                      </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开票金额" prop="inv_money">
                            <Input v-model="Forms.inv_money" type="number" clearable placeholder=""/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="发票类型" prop="inv_type">
                            <Select v-model="Forms.inv_type" clearable filterable  placeholder="收款类型" class="width-100">
                                <Option v-for="(item,index) in invTypeList" :key="index" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开票公司" prop="inv_company_id">
                            <Select v-model="Forms.inv_company_id" clearable filterable  placeholder="开票公司" class="width-100">
                                <Option v-for="(item,index) in companyList" :key="index" :value="item.company_id">{{item.company}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="上传发票" prop="invoice_image">
                            <Input v-model="Forms.invoice_image" disabled>
                                <template #append>
                                    <div class="f-center">
                                        <Upload
                                            :show-upload-list="false"
                                            :action="upload_url"
                                            :headers = "{'token': $store.state.token}"
                                            :format="['xls','xlsx','rar','zip','doc','docx','txt','docx','jpg','jpeg','png','pdf']"
                                            :max-size="50 * 1024"
                                            :on-success="handleSuccess"
                                            :on-format-error="handleFormatError"
                                            :on-exceeded-size="handleMaxSize">
                                            <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                        </Upload>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDelete()" class="text-danger"><Icon type="md-trash" />删除</a>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDownload()" class="text-violet"><Icon type="md-download" />下载</a>
                                    </div>
                                </template>
                            </Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="备注信息" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="备注信息" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认开发票</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getExpendInvoiceConfig, getExpendInvoiceDetail, saveExpendInvoice} from "@/apis/invoice/expend";

export default {
    name: 'ExpendInvoice',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '添加发票',
            isBox : false,
            invTypeList: [],
            companyList: [],
            Forms : {
                inv_id:'',
                title: '',
                inv_money: '',
                invoice_image: '',
                inv_type: '',
                inv_company_id: '',
                remark: ''
            },
            Rules : {
                title: [
                  { required: true, message: '请输入发票名称', trigger: 'blur'}
                ],
                inv_money: [
                    { required: true, type: 'number', min:0.1,  message: '请输入开票金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
                ],
                inv_type: [
                    { required: true, type: 'number',  message: '请选择发票类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                invoice_image: [
                    { required: true, message: '请上传发票', trigger: 'blur'}
                ],
                inv_company_id: [
                    { required: true, type: 'number',  message: '请选择开票公司', trigger: 'change',  transform(value) { return parseInt(value)}}
                ]
            },
            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,
        }
    },
    methods: {
        /**
         功能：图片文件
         time: 2025/12/17 10:48
         **/
        FileDelete(){
            let that = this;
            that.Forms.invoice_image = "";
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleSuccess(res){
            let that = this;
            if(res.code === 100){
                this.Forms.invoice_image = res.data.url;
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 xls | xlsx | rar | zip | doc | docx | txt | jpg | jpeg | png 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/19 18:12
         **/
        FileDownload(){
            let that = this;
            if(that.Forms.invoice_image){
                //下载文件
                const fileUrl = that.site_url + that.Forms.invoice_image; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },


        /**
         功能：
         time: 2025/12/25 16:29
         **/
        GetConfig(){
            let that = this;
            getExpendInvoiceConfig().then(e=>{
                that.invTypeList = e.data.invTypeList ?? [];
                that.companyList = e.data.companyList ?? [];
            })
        },

        GetDetail(inv_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getExpendInvoiceDetail(inv_id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'inv_type' || v === 'inv_company_id') {
                        that.Forms[v] = parseInt(data[v]);
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
                console.log(that.Forms)
            })
        },
        /**
         功能：
         time: 2025/12/25 16:08
         **/
        add(){
            this.isBox = true;
            this.GetConfig();
        },
        /**
         功能：
         time: 2026/1/7 09:50
         **/
        edit(inv_id){
            this.isBox = true;
            this.GetConfig();
            if(inv_id) this.GetDetail(inv_id);
        },
        /**
         功能：
         time: 2026/1/7 09:41
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveExpendInvoice(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2026/1/7 09:41
         **/
        FormReset(){
            this.isBox = false;
            this.title = '添加发票';
            this.$refs['Forms'].resetFields();
            this.Forms.invTypeList = [];
            this.Forms.companyList = [];
            this.Forms.inv_id = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
